module.exports = __webpack_public_path__ + "img/radio_on.d2d83503.svg";